const isLLMProcessingEnabledForType = ({ docConfig, newType, category }) => {
  const documentCategories =
    docConfig['DocClassification'].DocClassificationCategories[category];
  return documentCategories?.[newType]?.llmprocessing || false;
};

const getAllVisibleDocumentTypesForCategory = ({
  docConfig,
  category,
  defaultTypes,
}) => {
  const documentTypes = docConfig?.DocClassification?.DocumentTypes;
  const categoryConfig =
    docConfig?.DocClassification?.DocClassificationCategories?.[category];

  if (!categoryConfig) {
    return [...(defaultTypes ? defaultTypes : [])];
  }

  const visibleTypes = Object.entries(categoryConfig)
    .filter(([_, config]) => config?.display === true)
    .map(([key, _]) => documentTypes?.[key]?.name || key);

  return [...visibleTypes, ...(defaultTypes ? defaultTypes : [])];
};

const getAllLLMProcessingAndVisibleDocumentTypesForCategory = ({
  docConfig,
  category,
  defaultTypes,
}) => {
  const documentTypes = docConfig?.DocClassification?.DocumentTypes;
  const categoryConfig =
    docConfig?.DocClassification?.DocClassificationCategories?.[category];

  if (!categoryConfig) {
    return [...(defaultTypes ? defaultTypes : [])];
  }

  const visibleAndLLMTypes = Object.entries(categoryConfig)
    .filter(
      ([_, config]) =>
        config?.display === true && config?.llmprocessing === true
    )
    .map(([key, _]) => documentTypes?.[key]?.name || key);

  return [...visibleAndLLMTypes, ...(defaultTypes ? defaultTypes : [])];
};

const getAllDocumentTypesForCategory = ({
  docConfig,
  category,
  defaultTypes,
}) => {
  const documentTypes = docConfig?.DocClassification?.DocumentTypes;
  const categoryTypes = Object.keys(
    docConfig['DocClassification'].DocClassificationCategories[category]
  );

  const typeNames = categoryTypes
    ? categoryTypes.map((key) => documentTypes?.[key]?.name || key)
    : [];

  return [...typeNames, ...(defaultTypes ? [defaultTypes] : [])];
};

const categorizeDocument = ({ docConfig, docString, category }) => {
  let ret = 'Uncategorized';

  // Early return if config is missing or empty
  if (!docConfig || Object.keys(docConfig).length === 0) {
    return ret;
  }

  const availableDocumentTypes = getAllDocumentTypesForCategory({
    docConfig,
    category,
  });

  if (!availableDocumentTypes || availableDocumentTypes.length === 0) {
    return ret;
  }

  const documentTypes = docConfig?.['DocClassification']?.['DocumentTypes'];

  if (!documentTypes || Object.keys(documentTypes).length === 0) {
    return ret;
  }

  for (const typeName of availableDocumentTypes) {
    // Skip any types that might not be in documentTypes
    if (!documentTypes[typeName]) {
      continue;
    }

    const classification = documentTypes[typeName];
    const categorizeKeywords = classification?.fileNameKeywords;

    // Skip if no keywords defined
    if (!categorizeKeywords || categorizeKeywords.length === 0) {
      continue;
    }

    for (const value of categorizeKeywords) {
      const regex = new RegExp(`${value}`, 'i');
      if (regex.test(docString)) {
        return typeName;
      }
    }
  }

  return ret;
};

export {
  isLLMProcessingEnabledForType,
  getAllDocumentTypesForCategory,
  getAllVisibleDocumentTypesForCategory,
  getAllLLMProcessingAndVisibleDocumentTypesForCategory,
  categorizeDocument,
};
